<picture data-cy="nmo-picture">
  @for (source of this.sourceSet(); track source.sourceSet) {
    <source
      [srcset]="source.sourceSet.join(', ')"
      [type]="source.type"
      [attr.media]="source.media"
      [attr.sizes]="source.sizes.length > 0 ? source.sizes.join(', ') : undefined"
    />
  }
  <img
    [ngSrc]="this.fallbackSource()"
    [width]="this.defaultCropConfig().resize?.width"
    [height]="this.defaultCropConfig().resize?.height"
    [alt]="this.alt()"
    [priority]="this.priority()"
    [attr.title]="this.title()"
  />
</picture>
